define.alias("shared/components/shared/ui/profile-color-option", "preview-grid/components/shared/ui/profile-color-option");